<script>
    export default {
        props: {
            assetType: Object,
        },
        methods: {
            async selectAssetType() {
                this.$store.commit('ASSET_TYPE_DATA_EDIT_SET', this.assetType);
                this.$store.dispatch('CHECK_ASSET_TYPE_EDIT');
                this.$store.commit('IS_SHOW_ASSET_TYPE_EDIT',true);
            }
        }
    }
</script>


<template>
    <li>
        <div
            class="blur_white cursor_pointer_label"
            @click="selectAssetType"
        >
            <label>[{{ assetType['id'] }}]</label>
            <label
                class="ml_5"
            >{{ assetType['name'] }}</label>
        </div>
    </li>
</template>